"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, FlexColumn, interactiveVariants, Link, Separator, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { useConnect, useInjectedConnectors } from "../../../polychain/hooks";
import { ConnectModalState } from "../../../stores/connectModalStore";
import { EmailLogin } from "./components/EmailLogin";
import { MoreWalletOptions } from "./components/MoreWalletOptions/MoreWalletOptions";
import { SelectEcosystem } from "./components/SelectEcosystem";
import { WalletLogin } from "./components/WalletLogin";
export const ConnectModal = props => {
  const $ = _c(23);
  const t = useTranslations("wallet.ConnectModal");
  const {
    onConnected,
    switchOnConnect,
    isLinking
  } = props;
  const {
    step
  } = useSnapshot(ConnectModalState);
  const injectedConnectors = useInjectedConnectors();
  const hasInjectedConnectors = injectedConnectors.length > 0;
  let t0;
  if ($[0] !== isLinking || $[1] !== onConnected) {
    t0 = {
      onConnected,
      isLinking
    };
    $[0] = isLinking;
    $[1] = onConnected;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    connect
  } = useConnect(t0);
  switch (step.id) {
    case "more-wallet-options":
      {
        let t1;
        if ($[3] !== connect || $[4] !== switchOnConnect) {
          t1 = <MoreWalletOptions connect={connect} switchOnConnect={switchOnConnect} />;
          $[3] = connect;
          $[4] = switchOnConnect;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "select-ecosystem":
      {
        let t1;
        if ($[6] !== isLinking || $[7] !== onConnected || $[8] !== switchOnConnect) {
          t1 = <SelectEcosystem isLinking={isLinking} onConnected={onConnected} switchOnConnect={switchOnConnect} />;
          $[6] = isLinking;
          $[7] = onConnected;
          $[8] = switchOnConnect;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[10] !== connect || $[11] !== hasInjectedConnectors || $[12] !== isLinking || $[13] !== step.id || $[14] !== switchOnConnect || $[15] !== t) {
          t1 = <FlexColumn className="text-center">{hasInjectedConnectors ? <>{step.id === "pick-login-option" && <><WalletLogin connect={connect} isLinking={isLinking} switchOnConnect={switchOnConnect} /><TextSeparator text={t("orContinueWithEmail")} /></>}<EmailLogin connect={connect} isLinking={isLinking} switchOnConnect={switchOnConnect} /></> : <><EmailLogin connect={connect} isLinking={isLinking} switchOnConnect={switchOnConnect} />{step.id === "pick-login-option" && <><TextSeparator text={t("orConnectWallet")} /><WalletLogin connect={connect} isLinking={isLinking} switchOnConnect={switchOnConnect} /></>}</>}</FlexColumn>;
          $[10] = connect;
          $[11] = hasInjectedConnectors;
          $[12] = isLinking;
          $[13] = step.id;
          $[14] = switchOnConnect;
          $[15] = t;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        let t2;
        if ($[17] !== step.id || $[18] !== t) {
          t2 = step.id === "pick-login-option" && <TextBody className="text-center" color="text-secondary" size="xs">{t.rich("termsAndPrivacyNotice", {
              tosLink: _temp,
              privacyLink: _temp2
            })}</TextBody>;
          $[17] = step.id;
          $[18] = t;
          $[19] = t2;
        } else {
          t2 = $[19];
        }
        let t3;
        if ($[20] !== t1 || $[21] !== t2) {
          t3 = <FlexColumn className="gap-2">{t1}{t2}</FlexColumn>;
          $[20] = t1;
          $[21] = t2;
          $[22] = t3;
        } else {
          t3 = $[22];
        }
        return t3;
      }
  }
};
function TextSeparator(t0) {
  const $ = _c(6);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator className="w-auto flex-1" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <TextBody className="px-1" color="text-secondary" size="xs">{text}</TextBody>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator className="w-auto flex-1" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <CenterAligned className="relative my-2 h-8 flex-row gap-3">{t1}{t2}{t3}</CenterAligned>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp(children) {
  return <Link className={interactiveVariants({
    text: "primary"
  })} href="https://opensea.io/tos">{children}</Link>;
}
function _temp2(children_0) {
  return <Link className={interactiveVariants({
    text: "primary"
  })} href="https://opensea.io/privacy">{children_0}</Link>;
}